// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox-module__container___gmEd2","input":"checkbox-module__input___tU+d9","checkmark":"checkbox-module__checkmark___AMzfg","error":"checkbox-module__error___OOnum"};